// extracted by mini-css-extract-plugin
module.exports = {"root":"PermalinkView-root-ydU-a","replyList":"PermalinkView-replyList-2ypD2","title1":"PermalinkView-title1-zIGP4","title2":"PermalinkView-title2-1x2RT"};